import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 10000,
});

// Flavors
export const getFlavors = () => api.get('/flavors').then(r => r.data);
export const getFlavor = (id) => api.get(`/flavors/${id}`).then(r => r.data);
export const createFlavor = (data) => api.post('/admin/flavors', data).then(r => r.data);
export const updateFlavor = (id, data) => api.put(`/admin/flavors/${id}`, data).then(r => r.data);
export const deleteFlavor = (id) => api.delete(`/admin/flavors/${id}`).then(r => r.data);

// Products
export const getProducts = () => api.get('/products').then(r => r.data);
export const getProduct = (id) => api.get(`/products/${id}`).then(r => r.data);
export const createProduct = (data) => api.post('/products', data).then(r => r.data);
export const updateProduct = (id, data) => api.put(`/products/${id}`, data).then(r => r.data);
export const deleteProduct = (id) => api.delete(`/products/${id}`).then(r => r.data);

// Stores
export const getStores = (params = {}) => api.get('/stores', { params }).then(r => r.data);

// Newsletter
export const subscribeNewsletter = (data) => api.post('/newsletter/subscribe', data).then(r => r.data);

// Promo Codes
export const getPromoCodes = () => api.get('/admin/promo-codes').then(r => r.data);
export const createPromoCode = (data) => api.post('/admin/promo-codes', data).then(r => r.data);
export const updatePromoCode = (id, data) => api.put(`/admin/promo-codes/${id}`, data).then(r => r.data);
export const deletePromoCode = (id) => api.delete(`/admin/promo-codes/${id}`).then(r => r.data);
export const validatePromoCode = (code, orderTotal) => api.post('/promo-codes/validate', { code, orderTotal }).then(r => r.data);

// Admin
export const getAllProducts = () => api.get('/admin/products').then(r => r.data);

// Settings
export const getSettings = () => api.get('/settings').then(r => r.data);
export const updateSettings = (data) => api.put('/settings', data).then(r => r.data);

// Upload
export const uploadImage = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data);
};
